import { AxiosResponse } from 'axios';

import { envConfig } from '../../../config';
import { FileMetadataDto } from '../dtos/file-metadata.dto';
import { FileMetadataTypesEnum } from '../enums/file-metadata-types.enum';
import { ApkInfoModel } from '../models/apk-info.model';
import { castTo } from './cast-to';
import { createQueryParams } from './create-query-params/create-query-params.util';
import { generateId } from './generate-id/generate-id.util';
import { partitionFileIntoChunks } from './partition-file-into-chunks/partition-file-into-chunks.util';
import { sendFile } from './send.file';

export const sendFileChunks = async (
  file: File,
  fileType: FileMetadataTypesEnum,
  path: string,
  fileId?: string,
  apkInfo?: ApkInfoModel
): Promise<AxiosResponse<FileMetadataDto>> => {
  let response: AxiosResponse<FileMetadataDto> | null = null;
  const correlationId = fileId ?? generateId();
  const chunks = await partitionFileIntoChunks(file, envConfig.app.chunkSize);

  for (let i = 0; i < chunks.length; i++) {
    const queryParams = createQueryParams({
      chunkPart: i,
      totalChunks: chunks.length,
      correlationId,
    });
    response = await sendFile(
      file,
      fileType,
      path + queryParams,
      apkInfo,
      chunks[i]
    );
  }
  return castTo<AxiosResponse<FileMetadataDto>>(response);
};
